import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contextSidebar: false,
  theme: localStorage.getItem("theme") || "arya-blue",
};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setContextSidebar: (state: any, action: { payload: boolean }) => {
      state.contextSidebar = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
      localStorage.setItem("theme", action.payload);
    },
  },
});

export const { setContextSidebar, setTheme } = layoutSlice.actions;
export const getContextSidebar = (state: any) => state.layout.contextSidebar;
export const getTheme = (state: any) => state.layout.theme;

export default layoutSlice.reducer;
